import type { ID } from '@octopus-do/octopus-project-core'
import { LoaderActions } from '@store/loaders'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { managerActions } from '@store/reducers/manager/actions'
import { GeneralErrorNotification } from '@storeOld/reducers/notification'
import { LOCATION_CHANGE, push } from 'redux-first-history'
import { call, cancelled, put, race, select, take } from 'redux-saga/effects'

import { loadProjectSaga } from './fetchProjectSaga'

// Полузагруженный проект (meta.id уже записан, данных нет или они неполные)
// не должен остаться в сторе: иначе FetchProject на /:id решит, что проект
// загружен, и не перезапросит его
export function* rollbackProject(id: ID) {
  const projectId: ID | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (projectId === id) {
    yield put(managerActions.resetProject())
  }
}

// Открытие проекта из дашборда: сначала грузим проект в стор и только потом
// уходим на path (сам проект или место внутри него) — артборд монтируется
// уже с данными, без глобального лоадера.
// Пока идёт загрузка, карточка держит лоадер по id проекта, строка Activity —
// свой (иначе гаснут все строки этого проекта).
export function* openProjectSaga({
  payload: { id, path, loader = id },
}: ReturnType<typeof managerActions.openProjectSaga>) {
  yield put(LoaderActions.set(loader))

  try {
    // Пока грузились, пользователь мог уйти (Members, Back) или начать новый
    // проект (resetProject) — открытие отменяется вместе с HTTP-запросами
    const { left } = yield race({
      loaded: call(loadProjectSaga, id),
      left: take([LOCATION_CHANGE, managerActions.resetProject.type]),
    })

    if (left) {
      yield call(rollbackProject, id)

      return
    }

    yield put(push(path))
  } catch (error) {
    console.error('Error opening project:', error)

    yield call(rollbackProject, id)
    yield put(GeneralErrorNotification)
  } finally {
    // takeLatest: кликнули другую карточку
    const aborted: boolean = yield cancelled()

    if (aborted) {
      yield call(rollbackProject, id)
    }

    yield put(LoaderActions.unset(loader))
  }
}
